import { fileExtension, fileTypeIdentity, fileTypeLabel, formatFileSize, formatUploadedDate, previewKindFor, uploadedSortValue } from '@features/Attachments/utils/fileFormatting';
import { visibilityKeys, visibilitySortKey, visibilitySummary } from './visibility';
const UNCATEGORIZED_FILTER_VALUE = 'uncategorized';
/** Enriches one API row with every display/filter/sort value the surface and columns need. */
export function toBuildingAttachmentRow(api, translateFn) {
    var _a, _b, _c;
    const sizeBytes = (_a = api.fileSize) !== null && _a !== void 0 ? _a : 0;
    // Type, preview kind and extension come from the REAL filename, never from `name`. `name` is a
    // user-editable label and usually has no extension — deriving from it made every row render Type
    // "File", broke the File-type filter and the type sort, and stopped photos/PDFs/videos from
    // opening their viewer. Falls back to `name` only when a legacy row has no stored filename.
    const typeSource = ((_b = api.fileName) === null || _b === void 0 ? void 0 : _b.trim()) ? api.fileName : api.name;
    return {
        id: api.id,
        name: api.name,
        categoryId: api.attachmentCategoryId,
        categoryLabel: (_c = api.categoryName) !== null && _c !== void 0 ? _c : translateFn('no_category'),
        categoryFilterValue: api.attachmentCategoryId != null ? String(api.attachmentCategoryId) : UNCATEGORIZED_FILTER_VALUE,
        createdAt: api.createdAt,
        uploadedLabel: formatUploadedDate(api.createdAt),
        uploadedSortValue: uploadedSortValue(api.createdAt),
        sizeBytes,
        sizeLabel: formatFileSize(sizeBytes),
        isPrivate: api.isPrivate,
        showOnCustomerPortal: api.showOnCustomerPortal,
        visibilityKeys: visibilityKeys(api.isPrivate, api.showOnCustomerPortal),
        visibilitySortKey: visibilitySortKey(api.isPrivate, api.showOnCustomerPortal),
        visibilitySummary: visibilitySummary(api.isPrivate, api.showOnCustomerPortal, translateFn),
        typeLabel: fileTypeLabel(typeSource, translateFn),
        typeFilterValue: fileTypeIdentity(typeSource),
        previewKind: previewKindFor(typeSource),
        extension: fileExtension(typeSource),
        url: api.url
    };
}
